// Языки селекторов перевода, когда сервер ещё не отдал конфиг переводчика
// (translator.languages пуст). Единый список для ChatView (композер) и
// переключателя языков в шапке.
export const FALLBACK_TRANSLATE_LANGUAGES: Array<{ code: string; label: string }> = [
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
  { code: "uk", label: "UK" },
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "es", label: "ES" },
  { code: "sv", label: "SV" },
  { code: "tr", label: "TR" },
  { code: "ar", label: "AR" },
  // Северолевантийский (шами) диалект — переводится LLM-промптом, поэтому
  // код не ISO, а наш собственный (gateway маппит его в описание диалекта).
  { code: "ar-shami", label: "AR·шами" }
];

// Языки для селекторов: серверный список, отфильтрованный привязкой
// аккаунта (если админ ограничил набор). Пустой конфиг → fallback.
export const selectTranslateLanguages = (state: {
  accountId: string | null;
  translatorLanguages: Array<{ code: string; label: string }>;
  translatorBindings: Record<string, { languages?: string[]; defaultLanguage?: string }>;
}): Array<{ code: string; label: string }> => {
  const all =
    state.translatorLanguages.length > 0 ? state.translatorLanguages : FALLBACK_TRANSLATE_LANGUAGES;
  const binding = state.accountId ? state.translatorBindings[state.accountId] : undefined;
  const allowed =
    binding?.languages && binding.languages.length > 0
      ? all.filter((language) => binding.languages!.includes(language.code))
      : all;
  return allowed.length > 0 ? allowed : all;
};
